import styled, { css } from 'styled-components'
import { xsMd } from '../../theme/utils/media-query'
import { TABLET_WIDTH } from '../../theme/utils/media-query';

export function makePaper (element) {
  return styled(element)`
    margin: 0;
    height: 100%;
    width: ${TABLET_WIDTH}rem;

    text-align: ${props => props.textAlign ? props.textAlign : 'center'};

    ${xsMd(css`
      max-width: 100%;
    `)}
  `
}

export default makePaper